import React from 'react';
import { defineMessages, FormattedMessage } from 'react-intl';
import { StyleSheet, View } from 'react-native';

import { BodyText, Button, Icon, theme, useResponsive } from '@sg/garnish';

import { ForgotToScanFaqLink } from '../ForgotToScanFaqLink';

export const ForgotToScanLanding = (props: ForgotToScanLandingProps) => {
  const { title, subtitle, faqLink, onGetStartedPressed, onFaqPressed } = props;

  const { currentBreakpoint, match } = useResponsive();

  return (
    <View style={match([styles.containerXS, styles.containerSM])}>
      <View style={styles.content}>
        <Icon name="IconSgRewardKaleFill" width={67} height={67} />

        <BodyText style={styles.title} sizeMatch={['24']}>
          {title}
        </BodyText>

        <BodyText style={styles.text} sizeMatch={['16']}>
          {subtitle}
        </BodyText>
      </View>

      {currentBreakpoint.isXS ? (
        <View style={styles.content}>
          <Button size="large-wide" onPress={onGetStartedPressed}>
            <FormattedMessage {...messages.cta} />
          </Button>

          <ForgotToScanFaqLink link={faqLink} onPress={onFaqPressed} />
        </View>
      ) : null}
    </View>
  );
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  containerXS: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: theme.spacing['4'],
    paddingBottom: theme.spacing['10'],
  },
  containerSM: {
    alignItems: 'center',
  },
  content: {
    alignItems: 'center',
    gap: theme.spacing['6'],
  },
  title: {
    color: theme.colors.KALE,
    textAlign: 'center',
  },
  text: {
    textAlign: 'center',
  },
});

// ─── Messages ────────────────────────────────────────────────────────────────

const messages = defineMessages({
  cta: {
    defaultMessage: 'Get started',
    description: 'Forgot To Scan | Landing Page | Get started',
  },
  faqLinkPrefix: {
    defaultMessage: 'See',
    description: 'Forgot To Scan | Landing Page | FAQ',
  },
  faqLink: {
    defaultMessage: 'SG Rewards FAQ',
    description: 'Forgot To Scan | Landing Page | FAQ',
  },
  faqLinkSuffix: {
    defaultMessage: 'to learn more.',
    description: 'Forgot To Scan | Landing Page | FAQ',
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type ForgotToScanLandingProps = {
  title: string;
  subtitle: string;
  faqLink: string;
  onGetStartedPressed: () => void;
  onFaqPressed: () => void;
};
